import { NgModule } from '@angular/core';
import { B2bCommonModule } from '@siko/shared/b2b-common.module';
import { AsmComponentsModule } from '@spartacus/asm/components';
import {
   FormErrorsModule,
   IconModule,
   MessageComponentModule,
   PasswordVisibilityToggleModule,
} from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SikoCustomerSelectionComponent } from '@siko/features/asm/components/customer-selection/customer-selection.component';
import { SikoAsmMainUiComponent } from './components/asm-main-ui/asm-main-ui.component';
import { FeaturesConfigModule, I18nModule, TranslatePipe } from '@spartacus/core';
import { SikoButtonComponent } from '@siko/components/atomic';
import { SikoB2bCustomerEmulationComponent } from '@siko/features/asm/components/customer-emulation/customer-emulation.component';

@NgModule({
   imports: [
      B2bCommonModule,
      AsmComponentsModule,
      MessageComponentModule,
      IconModule,
      FormErrorsModule,
      ReactiveFormsModule,
      PasswordVisibilityToggleModule,
      FeaturesConfigModule,
      FormErrorsModule,
      FormsModule,
      I18nModule,
      ReactiveFormsModule,
      TranslatePipe,
      SikoButtonComponent,
      SikoB2bCustomerEmulationComponent,
   ],
   declarations: [SikoAsmMainUiComponent, SikoCustomerSelectionComponent],
   exports: [SikoCustomerSelectionComponent],
   providers: [],
})
export class SikoAsmComponentsModule {}
